// Infinite paging for object search: page 1 replaces the list, later pages add to it.
/** The loaded list after a page arrives. Rows already loaded (same id) are not added again; without an id field, pages just add up. */
export function mergePage(prev, items, page, idField) {
    if (page <= 1)
        return [...items];
    if (!idField)
        return [...prev, ...items];
    const seen = new Set(prev.map(r => String(r === null || r === void 0 ? void 0 : r[idField])));
    return [...prev, ...items.filter(r => !seen.has(String(r === null || r === void 0 ? void 0 : r[idField])))];
}
/** The token to ask the next page with: the one the reply gave, else how many rows are loaded (as DataList did). */
export function nextPageToken(pageToken, loaded) {
    return pageToken !== null && pageToken !== void 0 ? pageToken : String(loaded);
}
/** Whether another page can be asked for: by the total when known, else a full last page means maybe more. */
export function hasMorePages(loaded, total, lastBatch, pageSize) {
    if (total > 0)
        return loaded < total;
    return lastBatch >= pageSize;
}
